<app-modal class="roles-create-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.roles.update-modal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <div class="row alert-row">
            <div class="col s12">
                <app-alert *ngIf="isOobRole()"
                           [responsive]="true"
                           type="warning"
                           message="{{'admin.roles.update-modal.oob.warning'| translate}}"></app-alert>
            </div>
        </div>
        <form class="picklist-form"
              [formGroup]="form">
            <div class="form-group row">
                <div class="col s12">
                    <app-input formControlName="name"
                               [formControl]="form.controls.name"
                               [showErrors]="showValidations"
                               [isDisabled]="true"
                               placeholder="{{'admin.roles.create-modal.name-input.placeholder' | translate }}"
                               label="{{'admin.roles.create-modal.name-input.label' | translate}}">
                    </app-input>
                </div>
            </div>
            <div class="permissions-role">
                <app-picklist [source]="permissions"
                              [(target)]="role.permissions"
                              [disabled]="isOobRole()"
                              sourceHeader="{{'admin.roles.create-modal.permission-pick-list.leftHeader' | translate}}"
                              targetHeader="{{'admin.roles.create-modal.permission-pick-list.rightHeader' | translate}}"
                              infoLabel="{{'admin.roles.create-modal.alert.message' | translate}}"></app-picklist>
            </div>
            <div class="internal-positions-role">
                <app-picklist [source]="internalPositions"
                              [(target)]="role.internalPositions"
                              sourceHeader="{{'admin.roles.create-modal.internal-position-pick-list.leftHeader' | translate}}"
                              targetHeader="{{'admin.roles.create-modal.internal-position-pick-list.rightHeader' | translate}}"
                              infoLabel="{{'admin.roles.create-modal.alert.message' | translate}}"></app-picklist>
            </div>
        </form>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    class="waves-effect btn-flat"
                    [disabled]="isLoading"
                    (click)="modal.close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="buttons">
            <app-button *ngIf="shouldRenderModifiers"
                        [disabled]="isLoading"
                        type="warning"
                        (click)="updateRole()">
                {{ 'admin.roles.create-modal.button.update'| translate }}
            </app-button>
        </div>
    </div>
</app-modal>
